import { query } from '@/gql/apolloClient';
import CachePolicy from '@/gql/CachePolicy';
import {
  GET_BILLING_SUBSCRIPTION_TERM_END,
  GET_COMPANY_SUBSCRIPTIONS_QUERY,
  GET_CORE_PLAN_ACCESS,
} from '@/gql/queries/billing.gql';

export const getCompanySubscriptions = (data) =>
  query(
    GET_COMPANY_SUBSCRIPTIONS_QUERY,
    { data },
    'companySubscriptions',
    undefined
  );

// Plan access only (BIO-2085). no-cache: GET_BILLING_INFO stores the same
// getBillingInfo field with other coreSubscription fields, and coreSubscription
// has no id, so a cached write here would replace Plan Info's copy.
export const getCorePlanAccess = (companyId: string) =>
  query(GET_CORE_PLAN_ACCESS, { input: { companyId } }, 'getBillingInfo', {
    fetchPolicy: CachePolicy.NO_CACHE,
  });

// The term end for the confirm cancellation modal. Null for Stripe-billed
// companies; the modal falls back to the bill-cycle end there.
export const getBillingSubscriptionTermEnd = (companyId: string) =>
  query(
    GET_BILLING_SUBSCRIPTION_TERM_END,
    { companyId },
    'billingSubscription',
    { fetchPolicy: CachePolicy.NO_CACHE }
  );
